import { render, staticRenderFns } from "./GruppoEdit.vue?vue&type=template&id=24e51742"
import script from "./GruppoEdit.vue?vue&type=script&lang=js"
export * from "./GruppoEdit.vue?vue&type=script&lang=js"
import style0 from "./GruppoEdit.vue?vue&type=style&index=0&id=24e51742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports